import { FC } from 'react';

import { type DayGroup } from '@/shared/config';
import { Timeline } from '@/shared/ui';

import { type TranscriptorConsultation } from '@/entities/transcriptor';

import { RecordingRow, type RecordingRowActions } from '@/widgets/RecordingRow';

type RecordingsTimelineProps = {
  groups: DayGroup<TranscriptorConsultation>[];
  userTimezone: string;
  hideMode: boolean;
  className?: string;
  isConsultationStale: (consultation: TranscriptorConsultation) => boolean;
} & RecordingRowActions;

export const RecordingsTimeline: FC<RecordingsTimelineProps> = ({
  groups,
  userTimezone,
  hideMode,
  className,
  isConsultationStale,
  ...actions
}) => (
  <Timeline
    className={className}
    dataComponent="recordings-timeline"
    groups={groups}
    getItemKey={(consultation) => consultation.id}
    renderItem={(consultation) => (
      <RecordingRow
        consultation={consultation}
        userTimezone={userTimezone}
        hideMode={hideMode}
        isStale={isConsultationStale(consultation)}
        {...actions}
      />
    )}
  />
);
